// src/components/PageWrapper.jsx

import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import Navbar from './Navbar';
import BACKGROUND_IMAGE from 'assets/background2.jpg'; // Import background image here


//import BACKGROUND_IMAGE from 'assets/video/noirlab2012c.png'; // Import background image here


import { colors } from 'styles/PageStyles'; // Import global styles and colors

import SocialLinksBar from 'components/widgets/SocialLinksBar'




//REFACTOR
import 'fonts/font.css'; // Global font styles
import './style/style_centennial.css';
//ADD NAVIGATE STUFF
import { useNavigate } from 'react-router-dom';








const NAVBAR_HEIGHT = '4rem'; // Must match the height of your actual Navbar AppBar

const PageWrapper = ({ children, navbarPermanent = false }) => {
  const pageRef = useRef(null);
  const location = useLocation();




    const navigate = useNavigate();

    const handleNavigateClick = (url) => {
        console.log('click')
        if (url) {
            navigate(url);
        }
    };





    // 2. Updated function to handle both navigation and scrolling
    const handleNavigateAndScroll = (url) => {
      console.log('click and scroll');
      
      // --- SCROLL TO TOP LOGIC ---
      // Check if the ref is attached and has a scroll method (for a scrollable container)
      // OR, more reliably for the entire window/document:
      window.scrollTo({
          top: 0,
          behavior: 'smooth' // Optional: Makes the scroll smooth
      });
      
      // If the main div (pageRef.current) is the scrollable container, use this instead:
      // if (pageRef.current) {
      //     pageRef.current.scrollTo({
      //         top: 0,
      //         behavior: 'smooth'
      //     });
      // }
      // -----------------------------

      // 3. Perform the navigation after the scroll
      if (url) {
          // Use a short delay if scrolling the pageRef container to allow the DOM to update,
          // but for window.scrollTo, it's usually fine to run immediately.
          navigate(url);
      }
  };










  //   useEffect(() => {
  //     if (pageRef.current) {
  //       console.log(`PageWrapper: Scrolling to top for path: ${location.pathname}`);
  //       pageRef.current.scrollTo({ top: 0, behavior: 'smooth' });
  //     }
  //   }, [location.pathname]); // Re-run effect when the route changes







  const footerStyles = {
    width: '100%',
    padding: '20px',
    textAlign: 'center',
    backgroundColor: 'rgba(0,0,0,0.7)',
    color: colors.textColor,
    marginTop: 'auto',
    boxSizing: 'border-box',
    flexShrink: 0,

  };






  return (
    <div
      style={{
        // ...pageContainerStyles,
        backgroundImage: `url(${BACKGROUND_IMAGE})`, // Apply background image here
      }}
      ref={pageRef}
    >
      <Navbar initialPermanent={navbarPermanent} />





      {/* <div style={{ height: NAVBAR_HEIGHT }}></div> */}

      <main
        style={{
          margin: '0rem',
          padding: '0rem',
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {children}
      </main>









      <div style={{
        display: 'flex',
        justifyContent: 'center',
      }}>
        <p 
        className="div_return_home_button"
        // onClick={() => handleNavigateClick('/')}

        onClick={() => handleNavigateAndScroll('/')} 
        // style={{
        //   color: 'white',
        //   fontSize: '2rem',
        //   fontWeight: 'bold',
        //   fontFamily: 'orbitron',
        //   backgroundColor: 'rgba(25, 171, 240,0.20)',
        //   padding: '1rem',
        //   margin: '1rem',
        //   borderRadius: '1rem',
        //   cursor:'pointer',
        // }}
        
        >Return to Mission Base</p>
      </div>










      <footer style={footerStyles}>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}>
          <div
            style={{
              width: '80%',
              display:'flex',
              justifyContent:'center',
              flexDirection:'column',
            }}
          >

            <SocialLinksBar></SocialLinksBar>

            <p style={{ margin: 0 }}>
              © 2025 The Wonder Mission ®
            </p>
            {/* <p style={{ fontSize: '0.8rem', margin: '5px 0 0 0' }}>
              Images courtesy of NASA, NASA Jet Propulsion Laboratory, CalTech, Clark University, and Pond5.
            </p> */}

            <p style={{ fontSize: '0.8rem', margin: '15px 0 15px 0' }}>
              Images courtesy of NASA, NASA Jet Propulsion Laboratory, CalTech, and Pond5
            </p>
            <p style={{ fontSize: '0.8rem', margin: '5px 0 15px 0' }}>
              Goddard images courtesy of Clark University and WPI Archives and Special Collections
            </p>

            {/* <p style={{ fontSize: '0.8rem', margin: '5px 0 0 0' }}>
              <a href="/privacy-policy" style={{ color: colors.textColor, textDecoration: 'none' }}>Privacy Policy</a> |
              <a href="/cookie-policy" style={{ color: colors.textColor, textDecoration: 'none' }}> Cookie Policy</a>
            </p> */}

            <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
            <p style={{ maxWidth:'500px', fontSize: '0.8rem', margin: '5px 0 40px 0' }}>
              THE WONDER MISSION, [www.thewondermission.org] is a non-profit 501 (c)(3) organization dedicated to creating events and experiences that inspire the next generation of scientists, engineers, educators, innovators, and “visioneers.”
            </p>
            </div>


          </div>

        </div>
      </footer>
    </div>
  );
};

export default PageWrapper;